<template>
  <main>
    <!-- <st-header v-if="header" :header="header"></st-header> -->
    <reuters v-if="isReuters"></reuters>
    <st-article></st-article>
  </main>
</template>

<script>
import {mapState} from 'vuex'
import StHeader from './header/st-header.vue'
import StArticle from './st-article.vue'
import Reuters from './reuters.vue'

export default {
  components: {StHeader, StArticle, Reuters},
  computed: {
    ...mapState(['header']),
    isReuters () {
      return process.env.IS_REUTERS
    }
  }
}
</script>
